module.exports = __webpack_public_path__ + "img/41.c9c5b7f2.jpeg";